import { GetItemCounts, useInfiniteNames } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	ContentBlock,
	ContentLoader,
	FormWrapperLabel,
	SelectItemType,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { useEffect, useState } from 'react';
import { CustomComboBoxType } from '../../_Global/Types/FormTypes';

function NamesComboBox(props: CustomComboBoxType) {
	const { t } = useTranslation();

	const [shapedData, setShapedData] = useState<Array<SelectItemType>>([]);
	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const {
		status,
		data,
		error,
		hasNextPage,
		isStale,
		isRefetching,
		fetchNextPage,
		isFetchingNextPage,
		dataUpdatedAt,
	} = useInfiniteNames();

	const ShapeData = () => {
		const selectOptions: Array<SelectItemType> = [];

		if (!data) return;

		data.pages.map((page) => page.data.map((name) => selectOptions.push({ label: name.name, value: name.id })));
		setShapedData(selectOptions);
	};

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
			ShapeData();
		}
	}, [dataUpdatedAt]);

	return status === 'pending' ? (
		<ContentLoader round childCount={1} />
	) : status === 'error' ? (
		<ContentBlock error stacked title={error.name} content={error.message} />
	) : (
		<Controller
			control={props.control}
			name={props.name}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={props.label || t('mailboxes.filter.labels.names')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<ComboBoxControl
						data={shapedData}
						valueType='number'
						name={props.name}
						placeholder={props.placeholder || t('mailboxes.filter.controls.namesStatusPlaceholder')}
						loading={isFetchingNextPage}
						forwardValuesCallback={(e) => {
							field.onChange(e);
							if (props.onChangeCallback) {
								props.onChangeCallback(e);
							}
						}}
						forwardItemCallback={(e) => {
							if (props.onChangeItemsCallback) {
								props.onChangeItemsCallback(e);
							}
						}}
						pagination={{
							itemCounts,
							fetchNextPage,
							isFetchingNextPage,
							hasNextPage,
							isStale,
							isRefetching,
						}}
						defaultValue={props.defaultValues ? props.defaultValues : undefined}
						displayType={ComboBoxTypeEnum.Multi}
						displayItemLabelType={ComboBoxItemDisplayEnum.Label}
						conditionalReset={props.conditionalReset}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { NamesComboBox };
